import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "title-with-controls mb-4"
}
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "window-controls-group" }
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 1,
  class: "base-modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "overlayRef",
        class: _normalizeClass(["modal-overlay", { 'modal-overlay-cef': _ctx.cef }]),
        tabindex: "-1",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": _ctx.title || undefined,
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onBackdropClick && _ctx.onBackdropClick(...args)), ["self"]))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-content bg-dark text-light", [
        `modal-${_ctx.size}`,
        { 'modal-content-cef': _ctx.cef, 'modal-tall': _ctx.tall },
        _ctx.contentClass,
      ]]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-secondary window-control-btn",
                    title: _ctx.$t('common.close'),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                  ]))], 8, _hoisted_5)
                ])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true),
          (_ctx.$slots.footer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}